module.exports = __webpack_public_path__ + "img/nft6.0bbd5911.jpg";